import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";

import MainServices from "./pages/MainServices";
import ServiceCategory from "./pages/ServiceCategory";
import SubServiceDetail from "./pages/SubServiceDetail";

import "./styles/GlobalStyles.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/"        element={<Home />}     />
        <Route path="/about"   element={<About />}    />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/gallery"  element={<Gallery />}  />
        <Route path="/contact"  element={<Contact />}  />

        {/* DESIGN PLANNING FLOW */}
        <Route path="/services/main"               element={<MainServices />}    />
        <Route path="/services/design/:category"   element={<ServiceCategory />} />
        <Route path="/services/detail/:slug"       element={<SubServiceDetail />}/>
      </Routes>

      <Footer />

      {/* Floating buttons */}
      <WhatsAppButton />

    </Router>
  );
}

export default App;